import { API_BASE_URL } from './apiConfig';

/**
 * Fetch students with billing status and optional filters
 * @param {Object} params - { sessionId, course, page, limit, search }
 * @returns {Promise<{ success, students, pagination }>}
 */
export const getBillingStudents = async (params = {}) => {
  const sp = new URLSearchParams();
  if (params.sessionId) sp.set('sessionId', params.sessionId);
  if (params.course) sp.set('course', params.course);
  if (params.page) sp.set('page', params.page);
  if (params.limit) sp.set('limit', params.limit);
  if (params.search && params.search.trim()) sp.set('search', params.search.trim());
  const url = `${API_BASE_URL}/billing/students?${sp.toString()}`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${response.status}`);
  }
  return response.json();
};

/**
 * Mark a student as billed with invoice file upload
 * @param {FormData} formData - must include studentId and billingInvoice file; optional billingPeriodMonth, billingPeriodYear
 * @returns {Promise<{ success, data }>}
 */
export const markBilled = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/billing/mark-billed`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'Failed to add billing record');
  }
  return data;
};
